import { useState } from 'react';
import { useRepositories } from '../../../infrastructure/http/RepositoryProvider';
import { useAdminList } from './useAdminList';

// Log de emails enviados: se busca por destinatario y se filtra por tipo, de a una página.
export function useAdminEmails() {
  const { admin } = useRepositories();
  const [type, setType] = useState<string | null>(null);
  const list = useAdminList(
    (params) => admin.fetchEmails({ ...params, type }).then((r) => ({ items: r.emails, total: r.total })),
    [type]
  );
  return { ...list, type, setType };
}
